import React, { useState, useEffect } from 'react';
import moment from 'moment';
import InvoiceList from './InvoiceList';
import { addIds } from './helpers/invoiceListHelpers';
import * as api from '../../../../services/apis';
import { useAuthentication } from '../../../../hooks/useAuthentication';

const InvoiceListContainer = () => {
  const [renderInvoices, setRenderInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statistics, setStatistics] = useState({
    thisYear: 0,
    limit: 0,
    invoicesAllTime: 0,
    notesAllTime: 0,
    total: 0,
  });

  const { userInfo } = useAuthentication();

  const getInvoicesList = (tax_number) => {
    api
      .getInvoicesList(tax_number)
      .then((resp) => {
        const invoices = resp?.data || [];
        const generatedThisYear = Array.isArray(invoices) ? invoices.length : 0;
        const generatedInvoices = resp?.data?.generatedInvoices || 0;
        const generatedNotes = resp?.data?.generatedNotes || 0;
        setStatistics({
          thisYear: generatedThisYear,
          limit: 500,
          invoicesAllTime: +generatedInvoices,
          notesAllTime: +generatedNotes,
          total: +generatedInvoices + +generatedNotes,
        });
        // Transform data to add issueTime field
        const transformedInvoices = (
          Array.isArray(invoices) ? invoices : []
        ).map((invoice) => ({
          ...invoice,
          issueTime: invoice.issueDateTime
            ? moment(invoice.issueDateTime, 'YYYY-MM-DD HH:mm:ss').format(
                'HH:mm:ss',
              )
            : null,
        }));
        setRenderInvoices(transformedInvoices);
        setLoading(false);
      })
      .catch((err) => {
        console.log({ err });
        setRenderInvoices([]);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (userInfo) {
      getInvoicesList(userInfo.tax_number);
    }
  }, [userInfo]);

  const invoicesWithIds = addIds(renderInvoices);

  return (
    <InvoiceList
      statistics={statistics}
      invoices={invoicesWithIds}
      setRenderInvoices={setRenderInvoices}
      loading={loading}
      reloadInvoices={() => getInvoicesList(userInfo.tax_number)}
    />
  );
};

export default React.memo(InvoiceListContainer);
